import React, { useState, useEffect } from 'react';

import SelecterCheckbox from '../select/checkbox';

import { QuestionDesc } from '../../../../types';

import './index.less';
import SwiperDialog from '../../swiper-dialog';

type MultipleSelecterProps = {
    title?: string;
    value?: any;
    onChange?: (val: any) => void;
} & QuestionDesc &
    Props;

const MultipleSelecter: React.FC<MultipleSelecterProps> = (props: MultipleSelecterProps) => {
    const { title, value, data, dataType, dataKey, dataValue, limit, options } = props;
    const [visible, setVisible] = useState<boolean>(false);
    const [initStatus, setInitStatus] = useState<boolean>(false);
    const [dataArray, setDataArray] = useState<any[]>([]);

    const [localValue, setLocalValue] = useState<any>([]);
    useEffect(() => {
        if (!!value && value != localValue) {
            setLocalValue(value);
        }
    }, [localValue, value]);

    const handleVisible = () => {
        setInitStatus(true);
        setVisible(true);
    };
    const handleClose = () => {
        setLocalValue([...(value || [])]);
        setVisible(false);
    };
    const handleSure = () => {
        setVisible(false);
        props.onChange && props.onChange([...localValue]);
    };

    const handleChange = val => {
        setLocalValue(val);
    };
    const initDataArray = async () => {
        // const dataArrInstance = new SelectDataArray(options, dataType);
        // let arr = await dataArrInstance.getDataArray();
        setDataArray(options);
    };

    useEffect(() => {
        if (initStatus) {
            initDataArray();
        }
    }, [data, dataType, initDataArray, initStatus]);

    return (
        <div>
            <div onClick={handleVisible}>{props.children}</div>
            {initStatus && (
                <SwiperDialog
                    visible={visible}
                    title={title}
                    circle={true}
                    heightAuto={true}
                    showClose="center"
                    onClose={handleClose}
                    showSure={true}
                    onSure={handleSure}
                >
                    <div className="selecter-multiple-list">
                        <SelecterCheckbox
                            value={localValue}
                            data={options}
                            dataKey={dataKey}
                            dataValue={dataValue}
                            limit={limit}
                            onChange={handleChange}
                        />
                    </div>
                </SwiperDialog>
            )}
        </div>
    );
};

MultipleSelecter.defaultProps = {
    value: undefined,
    dataKey: 'seq',
    dataValue: 'content',
    onChange: val => {},
};

export default MultipleSelecter;
